<ng-container *ngIf="selectedColumns?.length">
    <div class="shadow-lg" *transloco="let translate">
        <div class="matTableContainer">
            <ng-container *ngIf="canShowTableData">
                <table
                    aria-describedby="encomply table"
                    #encomplyTable
                    mat-table
                    [dataSource]="dataSource"
                    multiTemplateDataRows
                    class="mat-elevation-z8 pAdjust"
                    matSort
                    [trackBy]="trackTableRecordData"
                    cdkDropList
                    (cdkDropListDropped)="dropRow($event)">
                    <ng-container
                        [matColumnDef]="column"
                        [sticky]="i < 1"
                        [stickyEnd]="
                            i === selectedColumns.length - 1 &&
                            (column === 'Table Actions' ||
                                column === 'log' ||
                                column === 'logs' ||
                                columnNameVsIds[column] === 'Table Actions' ||
                                columnNameVsIds[column] === 'log' ||
                                column === 'الإجراءات')
                        "
                        *ngFor="let column of selectedColumns; let i = index">
                        <ng-container
                            *ngIf="
                                column !== 'drag' &&
                                column !== 'log' &&
                                column !== 'checkbox' &&
                                column !== 'Active' &&
                                column !== 'active' &&
                                column !== 'نشط' &&
                                columnNameVsIds[column] !== 'Active' &&
                                columnNameVsIds[column] !== 'active' &&
                                column !== 'enabled' &&
                                columnNameVsIds[column] !== 'enabled' &&
                                column !== 'Table Actions' &&
                                column !== 'الإجراءات' &&
                                !columnsData[column]?.hasInput &&
                                !columnsData[column]?.hasCheckbox &&
                                column !== 'fileName' &&
                                column !== 'checkSum'
                            ">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <div
                                    mat-sort-header
                                    *ngIf="!translationEnabled && headerNamesToBeShown"
                                    [title]="column | pascalToCamel : headerNamesToBeShown">
                                    <span [textContent]="column | pascalToCamel : headerNamesToBeShown"></span>
                                </div>
                                <div
                                    mat-sort-header
                                    *ngIf="translationEnabled || !headerNamesToBeShown"
                                    [title]="translate(column | pascalToCamel : headerNamesToBeShown)">
                                    <span [textContent]="translate(column | pascalToCamel : headerNamesToBeShown)"></span>
                                </div>
                                <div *ngIf="columnSearchData[column]" class="columnSearchRequiredClass positionRelative uniqueSearch">
                                    <ng-container *ngIf="getColumnSearchConfig(column).type === 'text'">
                                        <mat-form-field>
                                            <mat-label *transloco="let translate">{{ translate('Search') }}</mat-label>
                                            <input
                                                matInput
                                                autocomplete="off"
                                                [formControl]="getSearchColumnControl(column)"
                                                floatLabel="never"
                                                debounce="500"
                                                (eventHandler)="searchInputModelChange(column)" />
                                            <material-button
                                                matSuffix
                                                buttonType="icon"
                                                size="small"
                                                [titleText]="'Search'"
                                                prefixIconType="material"
                                                prefixIcon="search"></material-button>
                                        </mat-form-field>
                                    </ng-container>
                                    <ng-container *ngIf="getColumnSearchConfig(column).type === 'boolean'">
                                        <mat-form-field class="booleanSearchField">
                                            <mat-label *transloco="let translate">{{ translate('Select') }}</mat-label>
                                            <mat-select
                                                [formControl]="getSearchColumnControl(column)"
                                                (selectionChange)="searchInputModelChange(column)">
                                                <mat-select-trigger>
                                                    <span
                                                        *ngIf="getSearchColumnControl(column).value === null"
                                                        [textContent]="translate('All')"></span>
                                                    <span
                                                        *ngIf="getSearchColumnControl(column).value === true"
                                                        [textContent]="translate('True')"></span>
                                                    <span
                                                        *ngIf="getSearchColumnControl(column).value === false"
                                                        [textContent]="translate('False')"></span>
                                                </mat-select-trigger>
                                                <mat-option [value]="null" [textContent]="translate('All')"></mat-option>
                                                <mat-option [value]="true" [textContent]="translate('True')"></mat-option>
                                                <mat-option [value]="false" [textContent]="translate('False')"></mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </ng-container>
                                    <ng-container *ngIf="getColumnSearchConfig(column).type === 'select'">
                                        <mat-form-field class="booleanSearchField">
                                            <mat-label *transloco="let translate">{{ translate('Select') }}</mat-label>
                                            <mat-select
                                                [formControl]="getSearchColumnControl(column)"
                                                (selectionChange)="searchInputModelChange(column)">
                                                <mat-option
                                                    *ngFor="let option of getColumnSearchConfig(column).options"
                                                    [value]="option.value"
                                                    [textContent]="translate(option.label)"></mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </ng-container>
                                    <ng-container *ngIf="getColumnSearchConfig(column).type === 'date'">
                                        <mat-form-field class="booleanSearchField">
                                            <mat-label *transloco="let translate">{{ translate('Select Date') }}</mat-label>
                                            <input
                                                matInput
                                                [matDatepicker]="picker"
                                                [formControl]="getSearchColumnControl(column)"
                                                (dateChange)="searchInputModelChange(column)" />
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                    </ng-container>
                                </div>
                                <div *ngIf="columnselectSearchRequired" class="tableColumnSelectSearch">
                                    <ng-container *ngIf="column === 'OrgName' || columnNameVsIds[column] === 'OrgName'">
                                        <mat-form-field appRemoveAriaOwns>
                                            <mat-label [textContent]="translate('Select')"></mat-label>
                                            <mat-select
                                                #selectedOrgMultipleList
                                                (keydown)="$event.stopPropagation()"
                                                multiple
                                                class="tableColumnSelect"
                                                [formControl]="selectedOrgs"
                                                panelClass="subsctiptionSelectPanel"
                                                (openedChange)="setTransformProperty()">
                                                <mat-option class="optionWithCheckBox matOptionWithCrossIcon flex justify-between">
                                                    <material-button
                                                        class="noOutline rejectColor clearSelectedListBtn"
                                                        [text]="translate('Clear')"
                                                        color="primary"
                                                        (click)="deselectAllOrg(); $event.stopPropagation()"
                                                        *ngIf="isSelectOrgPresent()"></material-button>
                                                    <input
                                                        class="inputInsideSelectInput"
                                                        [ngClass]="{ inputWithClearBtn: isSelectOrgPresent() }"
                                                        matInput
                                                        [placeholder]="translate('Search')"
                                                        [(ngModel)]="searchOrgString"
                                                        (click)="$event.stopPropagation()"
                                                        (keydown)="$event.stopPropagation()" />
                                                    <material-button
                                                        matSuffix
                                                        buttonType="icon"
                                                        size="small"
                                                        [titleText]="'Clear'"
                                                        prefixIconType="material"
                                                        prefixIcon="close"
                                                        *ngIf="searchOrgString.length > 0"
                                                        (buttonClicked)="$event.stopPropagation(); searchOrgString = ''"></material-button>
                                                </mat-option>
                                                <ng-container
                                                    *ngIf="allOrg | FilterPipe : 'name' : searchOrgString : null : 'orgLoginId' as result">
                                                    <label
                                                        class="noSearchResults"
                                                        *ngIf="!result.length"
                                                        [textContent]="translate('No organizations found')"></label>
                                                    <cdk-virtual-scroll-viewport itemSize="20" class="h-[212px]">
                                                        <mat-option
                                                            *cdkVirtualFor="let org of result; trackBy: allOrgTrackBy"
                                                            [value]="org.id"
                                                            (click)="organizationSelected(org, 'organization')"
                                                            [title]="org.name + ' (' + org.orgLoginId + ')'">
                                                            <span [textContent]="org.name + ' (' + org.orgLoginId + ')'"></span>
                                                        </mat-option>
                                                    </cdk-virtual-scroll-viewport>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="
                                            column === 'serviceName' ||
                                            column === 'displayName' ||
                                            columnNameVsIds[column] === 'serviceName' ||
                                            columnNameVsIds[column] === 'displayName'
                                        ">
                                        <mat-form-field appRemoveAriaOwns>
                                            <mat-label [textContent]="translate('Select')"></mat-label>
                                            <mat-select
                                                #selectedOrgAssetMultipleList
                                                (keydown)="$event.stopPropagation()"
                                                multiple
                                                [formControl]="selectedAsset"
                                                panelClass="subsctiptionSelectPanel"
                                                (openedChange)="setTransformProperty()">
                                                <mat-option class="optionWithCheckBox matOptionWithCrossIcon flex justify-between">
                                                    <material-button
                                                        *ngIf="isSelectOrgAssetPresent()"
                                                        class="noOutline rejectColor clearSelectedListBtn"
                                                        [text]="translate('Clear')"
                                                        color="primary"
                                                        (click)="deselectAllOrgAssets(); $event.stopPropagation()"></material-button>
                                                    <input
                                                        class="inputInsideSelectInput"
                                                        [ngClass]="{ inputWithClearBtn: isSelectOrgAssetPresent() }"
                                                        matInput
                                                        [placeholder]="translate('Search')"
                                                        [(ngModel)]="searchAssetOrgString"
                                                        (click)="$event.stopPropagation()"
                                                        (keydown)="$event.stopPropagation()" />
                                                    <material-button
                                                        matSuffix
                                                        buttonType="icon"
                                                        size="small"
                                                        [titleText]="'Clear'"
                                                        prefixIconType="material"
                                                        prefixIcon="close"
                                                        *ngIf="searchAssetOrgString.length > 0"
                                                        (buttonClicked)="
                                                            $event.stopPropagation(); searchAssetOrgString = ''
                                                        "></material-button>
                                                </mat-option>
                                                <ng-container
                                                    *ngIf="
                                                        allOrgAssets
                                                            | FilterPipe
                                                                : 'displayName'
                                                                : searchAssetOrgString
                                                                : null
                                                                : 'itemName' as result
                                                    ">
                                                    <label
                                                        class="noSearchResults"
                                                        *ngIf="!result.length"
                                                        [textContent]="translate('No apps found')"></label>
                                                    <cdk-virtual-scroll-viewport itemSize="20" class="h-[212px]">
                                                        <mat-option
                                                            *cdkVirtualFor="let app of result; trackBy: allOrgTrackBy"
                                                            [value]="app.id"
                                                            (click)="organizationSelected(app, 'asset')">
                                                            <span [textContent]="app.displayName || app.itemName"></span>
                                                        </mat-option>
                                                    </cdk-virtual-scroll-viewport>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                    </ng-container>
                                </div>
                            </th>
                            <ng-container *ngIf="columnsData[column]?.isDataCapturePresent">
                                <td mat-cell *matCellDef="let element" class="matTableCell">
                                    <ng-container *ngIf="rowsData[element.id][column].isDataCapturePresent">
                                        <mat-icon [title]="translate('Add Entity')" (click)="addEntity(element)">add_circle</mat-icon>
                                        <span *ngFor="let candidateEntity of element['associatedEntities']">
                                            <div>
                                                <span [textContent]="candidateEntity"></span>
                                            </div>
                                        </span>
                                    </ng-container>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="columnsData[column]?.isPassword">
                                <td mat-cell *matCellDef="let element" class="matTableCell">
                                    <span *ngIf="element[column]">*****</span>
                                </td>
                            </ng-container>
                            <ng-container *ngIf="column === 'status' || columnNameVsIds[column] === 'status'">
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                    class="matTableCell"
                                    [ngClass]="{
                                        widgetStatusApprove: element[column] === 'APPROVED',
                                        widgetStatusPending: element[column] === 'PENDING',
                                        widgetStatusDeactivate: element[column] === 'DEACTIVATED'
                                    }"
                                    [textContent]="element[column].charAt(0).toUpperCase() + element[column].slice(1).toLowerCase()"></td>
                            </ng-container>
                            <ng-container *ngIf="columnsData[column] && columnsData[column].isReportsPresent">
                                <td mat-cell *matCellDef="let element" class="matTableCell">
                                    <ng-container *ngIf="rowsData[element.id][column] && rowsData[element.id][column].isReportsPresent">
                                        <mat-icon [title]="translate('Manage Report')" (click)="addReport(element)">add_circle</mat-icon>
                                        <ul *ngFor="let candidateEntity of element['associatedReports']" class="addReportUl">
                                            <li *ngIf="candidateEntity.split('/')[1] !== undefined">
                                                <span [textContent]="candidateEntity.split('/')[1]"></span>
                                            </li>
                                            <li *ngIf="candidateEntity.split('/')[1] === undefined" [textContent]="candidateEntity"></li>
                                        </ul>
                                    </ng-container>
                                </td>
                            </ng-container>
                            <ng-container
                                *ngIf="
                                    !columnsData[column]?.isDataCapturePresent &&
                                    !columnsData[column]?.isReportsPresent &&
                                    !columnsData[column]?.isPassword
                                ">
                                <td
                                    mat-cell
                                    *matCellDef="let element"
                                    class="matTableCell"
                                    [ngClass]="wordWrap ? 'tableWrap' : 'tabelCellData'"
                                    (click)="copyElementId(element)">
                                    <span
                                        [ngClass]="wordWrap ? 'tableWrap' : 'tabelCellData'"
                                        [title]="addSpaceToTitle(element[column])"
                                        [innerHTML]="element[column]"
                                        [textContent]="element[column]"></span>
                                </td>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="inputInTableColumns && columnsData[column] && columnsData[column].hasInput">
                            <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="column | pascalToCamel"></span>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell">
                                <span class="tableInputClass">
                                    <material-input
                                        [autofocus]="false"
                                        [model]="element[column]"
                                        (modelChange)="element[column] = $event"></material-input>
                                </span>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="dragEnabled && (column === 'drag' || columnNameVsIds[column] === 'drag')">
                            <th class="w-[5%]" scope="col" mat-header-cell *matHeaderCellDef>
                                <mat-icon title="Reorder Rows">reorder</mat-icon>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-icon *ngIf="dragConditionProperty !== undefined && element[dragConditionProperty]">reorder</mat-icon>
                            </td>
                        </ng-container>
                        <!-- FOR COLUMNS WITH CHECKBOX -->
                        <ng-container *ngIf="columnsData[column] && columnsData[column].hasCheckbox">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="columnsWithCheckbox">
                                <material-checkbox
                                    [name]="column"
                                    [showName]="true"
                                    [model]="customerMasterCheck(column)"
                                    (modelChange)="customMasterToggle($event, column)"></material-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <material-checkbox
                                    *ngIf="canRenderCheckbox(element, column)"
                                    [model]="isTheValueChecked(element, column)"
                                    (modelChange)="changeCheckedValue(element, column)"
                                    [disabled]="checkForDisableValue(element, column)"></material-checkbox>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="column === 'checkbox' || columnNameVsIds[column] === 'checkbox'">
                            <th scope="col" mat-header-cell *matHeaderCellDef>
                                <material-checkbox
                                    [model]="selection.hasValue() && isAllSelected()"
                                    (modelChange)="masterToggle()"
                                    [badge]="selectedRecordsCount > 0 ? selectedRecordsCount : null"></material-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <material-checkbox
                                    [model]="selection.isSelected(element)"
                                    (modelChange)="onCheckboxSelection(element)"></material-checkbox>
                            </td>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                column === 'Active' ||
                                column === 'active' ||
                                column === 'نشط' ||
                                column === 'enabled' ||
                                columnNameVsIds[column] === 'Active' ||
                                columnNameVsIds[column] === 'active' ||
                                columnNameVsIds[column] === 'enabled'
                            ">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <div>
                                    <span [textContent]="translate('Active')"></span>
                                </div>
                                <ng-container *ngIf="columnSearchRequired">
                                    <div class="searchHiddenDiv"></div>
                                </ng-container>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell" (click)="$event.stopPropagation()">
                                <material-slidetoggle
                                    [model]="element[column]"
                                    (changeToggle)="changeStatus(element, $event?.inputSource)"
                                    [dontChangeImmediately]="dontChangeImmediately"
                                    [disabled]="adminUserId && element['User ID'] === adminUserId"></material-slidetoggle>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="column === 'fileName' || columnNameVsIds[column] === 'fileName'">
                            <th
                                scope="col"
                                mat-header-cell
                                *matHeaderCellDef
                                class="matTableHeader"
                                [textContent]="column | pascalToCamel : headerNamesToBeShown"></th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                [title]="element.fileName"
                                class="matTableCell"
                                (click)="$event.stopPropagation()">
                                <span
                                    class="accordian_body_text"
                                    (click)="downloadFile(element)"
                                    [title]="element.fileName"
                                    [textContent]="element.fileName"></span>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="column === 'checkSum' || columnNameVsIds[column] === 'checkSum'">
                            <th scope="col" *matHeaderCellDef class="matTableHeader" [textContent]="translate('Check Sum')"></th>
                            <td mat-cell *matCellDef="let element" class="matTableCell" (click)="$event.stopPropagation()">
                                <mat-form-field class="checkSum">
                                    <mat-label *transloco="let translate">{{ translate('Check Sum') }}</mat-label>
                                    <input matInput [(ngModel)]="element.checkSum" [value]="element.checkSum" />
                                </mat-form-field>
                                <mat-icon class="checkSumIcon" [title]="translate('Copy to clipboard')" (click)="copyCheckSum(element)">
                                    file_copy
                                </mat-icon>
                            </td>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                (column !== 'recordId' || columnNameVsIds[column] !== 'recordId') && actionColumns.indexOf(column) === -1
                            ">
                            <th scope="col" mat-sort-header mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span [textContent]="column | pascalToCamel"></span>
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                class="matTableCell"
                                [ngClass]="wordWrap ? 'tableWrap' : 'tabelCellData'">
                                <span [ngClass]="wordWrap ? 'tableWrap' : 'tabelCellData'" [textContent]="element[column]"></span>
                            </td>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                (column === 'Table Actions' || column === 'الإجراءات' || columnNameVsIds[column] === 'Table Actions') &&
                                noAction === false
                            ">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <div>
                                    <span [textContent]="translate('Actions')"></span>
                                </div>
                                <ng-container *ngIf="columnSearchRequired">
                                    <div class="searchHiddenDiv"></div>
                                </ng-container>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell">
                                <span class="material-icons logIcon" [matMenuTriggerFor]="actionsMenu" [title]="translate('Actions Menu')">
                                    more_horiz
                                </span>
                                <mat-menu
                                    #actionsMenu="matMenu"
                                    [overlapTrigger]="false"
                                    [class]="'tableLogMenu !bg-white'"
                                    xPosition="after">
                                    <ng-container *ngFor="let action of recordActions">
                                        <ng-container *ngIf="checkRecordActions(action, element)">
                                            <button
                                                mat-menu-item
                                                class="hover:!bg-[#0000000a]"
                                                (click)="action.onActionTrigger(element, drawer)">
                                                <span class="material-icons matTableActionIcon" *ngIf="action.iconName !== undefined">
                                                    <span [textContent]="action.iconName"></span>
                                                </span>
                                                <span [textContent]="action.displayName"></span>
                                            </button>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="!recordActions || recordActions.length === 0">
                                        <button
                                            mat-menu-item
                                            class="hover:!bg-[#0000000a]"
                                            [textContent]="translate('No Actions Found')"></button>
                                    </ng-container>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="column === 'checkbox' || columnNameVsIds[column] === 'checkbox'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader"></th>
                            <td mat-cell *matCellDef="let element" class="matTableCell" (click)="$event.stopPropagation()">
                                <material-checkbox
                                    [(model)]="element.selected"
                                    (modelChange)="checkMasterRecord.emit(element)"></material-checkbox>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="column === 'log' || columnNameVsIds[column] === 'log'">
                            <th scope="col" mat-header-cell *matHeaderCellDef class="matTableHeader">
                                <span class="material-icons logIcon" [matMenuTriggerFor]="logMenu" [title]="translate('Filter Columns')">
                                    menu
                                </span>
                                <mat-menu
                                    #logMenu="matMenu"
                                    [overlapTrigger]="false"
                                    [class]="'tableLogMenu !bg-white'"
                                    xPosition="after"
                                    yPosition="below">
                                    <div class="logMenu" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                                        <div class="logFilter" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                                            <mat-form-field>
                                                <mat-label *transloco="let translate">{{ translate('Filter Table Columns') }}</mat-label>
                                                <input matInput class="filterInput" autocomplete="off" [(ngModel)]="searchColumns" />
                                                <material-button
                                                    matSuffix
                                                    *ngIf="searchColumns?.length > 0"
                                                    buttonType="icon"
                                                    size="small"
                                                    [titleText]="'Clear'"
                                                    prefixIconType="material"
                                                    prefixIcon="close"
                                                    (buttonClicked)="$event.stopPropagation(); searchColumns = ''"></material-button>
                                            </mat-form-field>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div
                                                class="d-flex justify-content-around align-items-center checkStyle"
                                                (click)="$event.stopPropagation()"
                                                (keydown)="$event.stopPropagation()">
                                                <material-checkbox
                                                    class="selectAllBtn"
                                                    [name]="translate('Select All')"
                                                    [title]="translate('Select All')"
                                                    [model]="selectAll"
                                                    (modelChange)="selectAllFilters($event)"
                                                    [showName]="true"
                                                    id="selectAllLabel"
                                                    [disabled]="false"></material-checkbox>
                                            </div>
                                            <material-button
                                                [color]="'primary'"
                                                [disabled]="clonedColumns.length === 0"
                                                [text]="translate('Apply')"
                                                (buttonClicked)="cloneSubmit()"></material-button>
                                        </div>
                                        <div
                                            class="logListItems"
                                            *ngFor="let column of allColumns; let i = index"
                                            (click)="$event.stopPropagation()"
                                            (keydown)="$event.stopPropagation()">
                                            <ng-container
                                                *ngIf="
                                                    (!searchColumns ||
                                                        searchColumns.length === 0 ||
                                                        (searchColumns.length > 0 && searchColumn(column))) &&
                                                    actionColumns.indexOf(column) === -1 &&
                                                    !(hideTableColumns && hideTableColumns.indexOf(column) > -1)
                                                ">
                                                <div class="d-flex align-items-center tempList">
                                                    <div class="actionCheckBox mCheckbox">
                                                        <material-checkbox
                                                            [model]="clonedColumns.indexOf(column) > -1"
                                                            (modelChange)="checkboxSelect($event, column)"
                                                            [name]="translate(column | pascalToCamel : headerNamesToBeShown)"
                                                            [showName]="true"></material-checkbox>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </mat-menu>
                                <ng-container *ngIf="columnSearchRequired">
                                    <div class="searchHiddenDiv"></div>
                                </ng-container>
                            </th>
                            <td mat-cell *matCellDef="let element" class="matTableCell" [textContent]="column && element[column]"></td>
                        </ng-container>
                    </ng-container>
                    <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let element" [attr.colspan]="selectedColumns.length">
                            <div
                                class="example-element-detail"
                                [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"></div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="loading">
                        <td
                            mat-footer-cell
                            class="matTableMessages"
                            *matFooterCellDef
                            colspan="100%"
                            [textContent]="translate('Loading Data...')"></td>
                    </ng-container>
                    <ng-container matColumnDef="noData">
                        <td mat-footer-cell class="matTableMessages" *matFooterCellDef colspan="100%">
                            <span [textContent]="noRecordMsg || translate('No Records Found')"></span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="noRecords">
                        <td
                            mat-footer-cell
                            class="matTableMessages noRecordMessage"
                            *matFooterCellDef
                            colspan="100%"
                            [textContent]="translate('No Records Found')"></td>
                    </ng-container>
                    <tr
                        mat-header-row
                        *matHeaderRowDef="selectedColumns; sticky: true"
                        [ngClass]="{ tableHeaderPadding: columnSearchRequired }"></tr>
                    <tr
                        mat-row
                        *matRowDef="let element; columns: selectedColumns"
                        class="example-element-row"
                        [class.example-expanded-row]="expandedElement === element"
                        [class.matTableError]="element.errorsCount && element.errorsCount > 0"
                        [class.matTableWarning]="element.warningsCount && element.warningsCount > 0"
                        [class.selectedRow]="selectedRecord?.id === element?.id"
                        [class.rowCanDraggable]="dragEnabled && dragConditionProperty !== undefined && element[dragConditionProperty]"
                        (click)="onSingleClick(element)"
                        (dblclick)="onDoubleClick(element)"
                        cdkDrag
                        [cdkDragDisabled]="!dragEnabled || !(dragConditionProperty !== undefined && element[dragConditionProperty])"></tr>
                    <div *cdkDragPlaceholder></div>
                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                    <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{ taxHide: dataSource != null }"></tr>
                    <tr
                        mat-footer-row
                        *matFooterRowDef="['noData']"
                        [ngClass]="{ taxHide: !(dataSource != null && dataSource.data.length === 0) || noRecordsFound }"></tr>
                    <tr mat-footer-row *matFooterRowDef="['noRecords']" [ngClass]="{ taxHide: !noRecordsFound }"></tr>
                </table>
            </ng-container>
            <ng-container *ngIf="showingLoadingData">
                <table aria-describedby="encomply table" mat-table [dataSource]="dataSourceLoading" class="mat-elevation-z8">
                    <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumnsWhileLoading; let i = index">
                        <th scope="col" mat-header-cell *matHeaderCellDef class="paddingleft15px">
                            <span class="loaderBlock isLoading" [textContent]="column"></span>
                        </th>
                        <td mat-cell *matCellDef="let element" class="paddingleft15px">
                            <span class="loaderBlock isLoading" [textContent]="element[column]"></span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWhileLoading"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnsToDisplayWhileLoading"></tr>
                </table>
            </ng-container>
        </div>
        <ng-container
            *ngIf="hidePaginator !== true && pagination && (data.length > 0 || pagination?.count > 0 || pagination.pageIndex > 0)">
            <encomply-material-paginator
                [pagination]="pagination"
                [showFirstLastButtons]="showFirstLastButtons"
                (fetchItemsInPage)="fetchItemsInPage.emit($event)"
                (refreshItemsWithNewPageSize)="refreshItemsWithNewPageSize.emit($event)"></encomply-material-paginator>
        </ng-container>
        <ng-container *ngIf="defaultPaginator">
            <mat-paginator
                class="sticky"
                [hidden]="data.length === 0 && pagination?.pageIndex === 0"
                #defaultMatPaginator
                [pageSizeOptions]="[5, 10, 20]"
                [length]="data.length"
                [pageSize]="10"
                showFirstLastButtons="true"></mat-paginator>
        </ng-container>
        <ng-container *ngIf="(data.length > 0 || pagination?.count > 0 || pagination?.pageIndex > 0) && newCustomPaginator">
            <div class="newCustomPagination" *transloco="let translate">
                <ul class="newCustomPaginationUl">
                    <li class="newCustomPaginationLi newCustomPaginationPageIndex">
                        <mat-form-field appRemoveAriaOwns>
                            <mat-label [textContent]="translate('Page Index')"></mat-label>
                            <mat-select [(value)]="pageIndexSelected" [disabled]="customPageIndex.length < 2">
                                <mat-option
                                    *ngFor="let index of customPageIndex"
                                    [value]="index"
                                    (click)="fetchItemsInPageWithPageIndex.emit(index)">
                                    <span [textContent]="index"></span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </li>
                    <li class="newCustomPaginationLi newCustomPaginationPageIndex">
                        <mat-form-field appRemoveAriaOwns>
                            <mat-label [textContent]="translate('Page Size')"></mat-label>
                            <mat-select [(value)]="sizeSelected">
                                <mat-option *ngFor="let size of customSize" [value]="size" (click)="refreshItemsWithNewPageSize.emit(size)">
                                    <span [textContent]="size"></span>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </li>
                    <li class="newCustomPaginationLi newCustomPaginationArrows">
                        <mat-icon
                            class="leftArrow"
                            [ngClass]="{ disable: disablePrevious }"
                            [title]="translate('previous')"
                            (click)="getPreviousRecords()">
                            chevron_left
                        </mat-icon>
                        <mat-icon
                            class="rightArrow"
                            [title]="translate('next')"
                            [ngClass]="{ disable: disableNext }"
                            (click)="getNextRecords()">
                            chevron_right
                        </mat-icon>
                    </li>
                </ul>
            </div>
        </ng-container>
    </div>
</ng-container>
